export default __webpack_public_path__ + "static/media/buzzer-full-blue.3d0f5626.png";